var map = {
	"./BrutalType-Bold/BrutalType-Bold.woff2": 1030,
	"./BrutalType-Medium/BrutalType-Medium.woff2": 1031,
	"./BrutalType-Regular/BrutalType-Regular.woff2": 1032
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1029;